import * as React from "react";
import { PlusOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";
import { Table, Button, Input, Row, Col, Divider } from "antd";
import { SpinProps } from "antd/lib/spin";
import DeleteModal from "./DeleteModal";
import Highlighter from "react-highlight-words";
import Title from "antd/lib/typography/Title";
import GridActionsDropdown, { TGridAction } from "./GridActionsDropdown";
import Text from "antd/lib/typography/Text";
import { DataGridConstants } from "../../../common/Constants";
import { TTranslate } from "../../../service/locale/TranslationService";
import { get } from "lodash";
import { FormInstance } from "antd/lib/form";
import { TablePaginationConfig } from "antd/lib/table/interface";
import GridEditorModal from "./GridEditorModal";
import { TFormAction } from "./FormAction";
import _ from "lodash";
export interface State {
  createModalVisible: boolean;
  updateModalVisible: boolean;
  deleteModalVisible: boolean;
  rowData: any;
  expandedRowKeys: React.ReactText[];
  searchText: string;
  searchedColumn: string;
  pageSize: number;
}

export interface Props {
  translate: TTranslate;
  columns: any[];
  dataSource: any[];
  actions?: TGridAction[];
  loading?: boolean | SpinProps;
  allowCreate?: boolean;
  allowDelete?: boolean;
  allowUpdate?: boolean;
  title?: React.ReactElement | string;
  icon?: string;
  datagridTitleClass?: any;
  createModalTitle?: string;
  createForm?: any;
  createModalClass?: any;
  onCreate?: any;
  onUpdate?: any;
  onDelete?: any;
  getCodebook?: any;
  updateModalTitle?: string;
  updateForm?: any;
  updateModalClass?: any;
  deleteModalTitle?: string;
  addButtonText?: string;
  addButtonType?: any;
  deleteModalMessage?: string;
  expandedRowRender?: any;
  singleRowExpandEnabled?: boolean;
  onExpand?: any;
  expandRowByClick?: boolean;
  onExpandedRowsChange?: any;
  childrenColumnName?: string;
  indentSize?: number;
  editableRecordProp?: string;
  codebooks?: any;
  booleanColumnKeys?: string[];
  keyProperty: string;
  horizontalScroll?: string | number | boolean | undefined;
  addButtonStyle?: any;
  actionColumnWidth?: string | number;
  onStartUpdate?: (any?) => any;
  onStartCreate?: (any?) => any;
  onEndUpdate?: (any?) => any;
  onEndCreate?: (any?) => any;
  createModalVisible?: boolean;
  updateModalVisible?: boolean;
  onCancelCreateModal?: (any) => any;
  CreateFormInstance?: FormInstance;
  UpdateFormInstance?: FormInstance;
  className?: any;
  showHeader?: boolean;
  isTableInvisible?: boolean;
  onChange?: any;
  pageSize?: number;
  recordStartEditingBehavior?: "row" | "button" | "cell";
  createActionPosition?: "topRight" | "footer";
  createFormActions?: TFormAction[];
  updateFormActions?: TFormAction[];
  style?: React.CSSProperties;
  rowClickAction?: string;
}

export default class DataGrid extends React.Component<Props, State> {
  private searchInput: any;
  constructor(props: any) {
    super(props);
    this.state = {
      createModalVisible: false,
      updateModalVisible: false,
      deleteModalVisible: false,
      rowData: {} as any,
      expandedRowKeys: [],
      searchText: "",
      searchedColumn: "",
      pageSize:
        props.pageSize != null
          ? props.pageSize
          : DataGridConstants.MIN_PAGE_SIZE
    };
    this.buildActionsColumn = this.buildActionsColumn.bind(this);
    this.buildPaginationOption = this.buildPaginationOption.bind(this);
    this.showUpdateModal = this.showUpdateModal.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { createModalVisible, updateModalVisible } = this.props;
    let prevStateCreateModalVisible = prevState?.createModalVisible;
    let prevStateUpdateModalVisible = prevState?.updateModalVisible;

    if (
      createModalVisible !== undefined &&
      createModalVisible !== prevStateCreateModalVisible
    ) {
      this.setState({
        createModalVisible
      });
    }
    if (
      updateModalVisible !== undefined &&
      updateModalVisible !== prevStateUpdateModalVisible
    ) {
      this.setState({
        updateModalVisible
      });
    }
  }

  render() {
    const {
      dataSource,
      loading,
      translate,
      allowCreate = false,
      allowDelete = false,
      allowUpdate = false,
      createModalTitle,
      createModalClass,
      createForm,
      onCreate,
      onUpdate,
      onDelete,
      childrenColumnName,
      updateModalTitle,
      updateModalClass,
      updateForm,
      deleteModalTitle,
      addButtonText,
      deleteModalMessage,
      indentSize,
      expandedRowRender,
      singleRowExpandEnabled,
      onExpand,
      expandRowByClick = false,
      editableRecordProp,
      booleanColumnKeys,
      keyProperty,
      title,
      icon,
      datagridTitleClass,
      horizontalScroll = true,
      addButtonStyle,
      addButtonType,
      onCancelCreateModal,
      CreateFormInstance,
      UpdateFormInstance,
      className,

      showHeader = true,
      isTableInvisible = false,
      onChange,
      recordStartEditingBehavior = "button",
      createActionPosition = "footer",
      createFormActions,
      updateFormActions,
      style,
      rowClickAction
    } = this.props;

    const {
      createModalVisible,
      updateModalVisible,
      deleteModalVisible,
      rowData,
      expandedRowKeys
    } = this.state;

    let { columns } = this.props;

    const locale = {
      emptyText: translate("data_grid.empty_text"),
      filterConfirm: translate("data_grid.filter_confirm"),
      filterReset: translate("data_grid.filter_reset")
    };

    const showCreateModal = (e) => {
      let newRowData = {};
      if (this.props.onStartCreate) {
        newRowData = this.props.onStartCreate(rowData);
      }
      CreateFormInstance?.setFieldsValue(newRowData);
      this.setState({
        createModalVisible: true,
        rowData: newRowData
      });
    };
    const endCreateModal = (e) => {
      let cancelResult = true;
      if (this.props.onEndCreate) {
        cancelResult = this.props.onEndCreate(e);
      }
      this.setState({
        createModalVisible: !cancelResult
      });
      return cancelResult;
    };

    const cancelCreateModal = (e) => {
      let cancelResult = false;

      this.setState({
        createModalVisible: cancelResult
      });
      onCancelCreateModal && onCancelCreateModal(e);
    };

    const showUpdateModal = this.showUpdateModal;

    const cancelUpdateModal = (e) => {
      this.setState({
        updateModalVisible: false
      });
      if (this.props.onEndUpdate) {
        this.props.onEndUpdate();
      }
    };

    const endUpdateModal = (e) => {
      let cancelResult = true;
      if (this.props.onEndUpdate) {
        cancelResult = this.props.onEndUpdate(e);
      }
      this.setState({
        updateModalVisible: !cancelResult
      });
      return cancelResult;
    };

    const showDeleteModal = (e, rowData) => {
      this.setState({
        deleteModalVisible: true,
        rowData
      });
    };

    const cancelDeleteModal = (e) => {
      this.setState({
        deleteModalVisible: false
      });
    };

    const singleRowExpandLimiter = (expandedRowKeys) => {
      expandedRowKeys = [expandedRowKeys[expandedRowKeys.length - 1]];
      this.setState({ expandedRowKeys });
    };

    columns = this.buildActionsColumn(
      allowUpdate,
      allowDelete,
      columns,
      this.props.actions || [],
      translate,
      editableRecordProp,
      showUpdateModal,
      showDeleteModal,
      recordStartEditingBehavior,
      rowClickAction
    );

    const getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              this.searchInput = node;
            }}
            placeholder={translate("data_grid.column_search.input")}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            {translate("data_grid.column_search.search")}
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            {translate("data_grid.column_search.reset")}
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{
            color: filtered ? "#1890ff" : undefined
          }}
        />
      ),
      onFilter: (value, record) =>
        (get(record, dataIndex) || "")
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => this.searchInput.select());
        }
      },
      render: (text) =>
        text && (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[this.state.searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        )
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      this.setState({ searchText: selectedKeys[0], searchedColumn: dataIndex });
    };

    const handleReset = (clearFilters) => {
      clearFilters();
      this.setState({ searchText: "", searchedColumn: "" });
    };

    const customExpandIcon = (props) => {
      return (
        <RightOutlined
          rotate={props.expanded ? 90 : 0}
          style={{ color: "rgba(0, 0, 0, 0.65)", marginRight: 7 }}
          onClick={(e) => {
            props.onExpand(props.record, e);
          }}
        />
      );
    };

    return (
      <div
        className={"datagrid" + className || ""}
        style={Object.assign({}, style, {})}
      >
        <Row className={"datagrid-header"}>
          <Col lg={18} sm={13}>
            <div className={"datagrid-title-wrapper"}>
              {icon && <i className={"datagrid-title-icon " + icon}></i>}
              {title ? (
                typeof title === "string" ? (
                  <Title
                    level={1}
                    className={"datagrid-title " + datagridTitleClass}
                  >
                    {title}
                  </Title>
                ) : (
                  title
                )
              ) : null}
            </div>
          </Col>
          <Col lg={6} sm={11} style={{ textAlign: "right" }}>
            {allowCreate && createActionPosition === "topRight" && (
              <Button
                size={"small"}
                className="datagrid-add-btn"
                type={addButtonType || "primary"}
                onClick={showCreateModal}
                style={addButtonStyle}
                icon={<PlusOutlined />}
              >
                {addButtonText}
              </Button>
            )}
          </Col>
        </Row>
        {(title || (allowCreate && createActionPosition === "topRight")) && (
          <Divider type={"horizontal"} className={"divider-horizontal"} />
        )}
        <div className={"datagrid-table"}>
          {!isTableInvisible && (
            <Table
              style={style}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (e) => this.onRowClick(e, record, rowIndex || -1)
                };
              }}
              childrenColumnName={childrenColumnName}
              indentSize={indentSize}
              rowKey={(record: any) => record[keyProperty].toString()}
              columns={columns.map((item) => ({
                ...item,
                sortDirections: ["descend", "ascend"],
                sorter:
                  item.key !== "actions" && !item.sorter
                    ? (a, b) =>
                        (String(get(a, item.dataIndex)) || "").localeCompare(
                          String(get(b, item.dataIndex)) || ""
                        )
                    : item.sorter ?? undefined,
                ...((item.dataIndex && !booleanColumnKeys) ||
                (item.dataIndex &&
                  booleanColumnKeys &&
                  booleanColumnKeys.filter((key) => key === item.dataIndex)
                    .length === 0)
                  ? getColumnSearchProps(item.dataIndex)
                  : item)
              }))}
              dataSource={dataSource}
              loading={loading}
              locale={locale}
              rowClassName={
                recordStartEditingBehavior === "row" || rowClickAction != null
                  ? "row-edit-behavior"
                  : ""
              }
              bordered={false}
              pagination={this.buildPaginationOption(dataSource, translate)}
              scroll={{ x: horizontalScroll ? horizontalScroll : undefined }}
              sortDirections={["descend", "ascend"]}
              expandedRowRender={expandedRowRender}
              expandIcon={(props) =>
                !_.isEmpty(props.expandable)
                  ? customExpandIcon(props)
                  : undefined
              }
              onExpand={onExpand}
              onExpandedRowsChange={(e) => {
                if (singleRowExpandEnabled) {
                  singleRowExpandLimiter(e);
                } else {
                  this.setState({ expandedRowKeys: e });
                }
              }}
              expandedRowKeys={expandedRowKeys || []}
              expandRowByClick={expandRowByClick}
              size={"small"}
              showHeader={showHeader}
              onChange={onChange}
              footer={
                createActionPosition === "footer" && allowCreate
                  ? () => (
                      <Row align="middle" justify="center">
                        <Col>
                          <Button
                            size={"small"}
                            className="datagrid-add-btn"
                            type={"link"}
                            onClick={showCreateModal}
                            style={addButtonStyle}
                            icon={<PlusOutlined />}
                          >
                            {addButtonText}
                          </Button>
                        </Col>
                      </Row>
                    )
                  : undefined
              }
            />
          )}
          {createModalVisible && (
            <GridEditorModal
              translate={translate}
              title={createModalTitle}
              visible={createModalVisible}
              onCancel={cancelCreateModal}
              onSubmit={onCreate}
              Form={createForm}
              className={createModalClass}
              formInstance={CreateFormInstance}
              onFinishEditing={endCreateModal}
              rowData={rowData}
              formActions={createFormActions}
            />
          )}
          {updateModalVisible && (
            <GridEditorModal
              translate={translate}
              title={updateModalTitle}
              visible={updateModalVisible}
              onCancel={cancelUpdateModal}
              onSubmit={onUpdate}
              Form={updateForm}
              rowData={rowData}
              className={updateModalClass}
              formInstance={UpdateFormInstance}
              onFinishEditing={endUpdateModal}
              formActions={updateFormActions}
            />
          )}
          {deleteModalVisible && (
            <DeleteModal
              translate={translate}
              title={deleteModalTitle}
              visible={deleteModalVisible}
              onCancel={cancelDeleteModal}
              onDelete={onDelete}
              message={deleteModalMessage}
              rowData={rowData}
            />
          )}
        </div>
      </div>
    );
  }

  private showUpdateModal(e, rowData) {
    if (this.props.onStartUpdate) {
      this.props.onStartUpdate(rowData);
    }
    this.setState({
      updateModalVisible: true,
      rowData
    });
  }

  private buildPaginationOption(
    dataSource: any[],
    translate: TTranslate
  ): TablePaginationConfig | false {
    let { pageSize } = this.props;
    if (pageSize == null) {
      return false;
    }
    if (pageSize <= 0) {
      return false;
    }
    pageSize = pageSize || DataGridConstants.MIN_PAGE_SIZE;
    if (dataSource.length < pageSize) {
      return false;
    }
    return {
      hideOnSinglePage: pageSize >= dataSource.length || !this.props.pageSize,
      showSizeChanger: true,
      position: ["bottomRight"],
      defaultPageSize: pageSize,
      total: dataSource.length,
      pageSize: this.state.pageSize,
      onShowSizeChange: (current, size) => {
        this.setState({ pageSize: size });
      },
      locale: {
        items_per_page: translate("data_grid.pagination.items_per_page")
      },
      showTotal: (total, range) => (
        <Text style={{ position: "absolute", left: 0 }}>{`${translate(
          "data_grid.pagination.showing"
        )} ${range[0]} ${translate("data_grid.pagination.to")} ${
          range[1]
        } ${translate("data_grid.pagination.total")} ${total}`}</Text>
      ),
      pageSizeOptions:
        dataSource.length > 30
          ? ["5", "10", "20", "30", dataSource.length.toString()]
          : ["5", "10", "20", "30"]
    };
  }

  private onRowClick(
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    record: any,
    rowIndex: number
  ) {
    const {
      recordStartEditingBehavior,
      editableRecordProp,
      allowUpdate,
      actions,
      rowClickAction
    } = this.props;
    if (
      (e.target as any)?.parentElement?.localName !== "button" &&
      ((e.target as any)?.className === "ant-table-cell" ||
        ["span", "div", "p", "strong"].indexOf((e.target as any)?.localName) !==
          -1)
    ) {
      const enabled =
        allowUpdate && (editableRecordProp ? record[editableRecordProp] : true)
          ? true
          : false;
      if (enabled && recordStartEditingBehavior === "row") {
        this.showUpdateModal(e, record);
        e.stopPropagation();
      }
      let action = actions?.find((item) => item.id === rowClickAction);
      if (action) {
        action.onClick(record)(e);
        e.stopPropagation();
      }
    }
  }

  private onCellClick(e, record: any, rowIndex: number) {
    const { recordStartEditingBehavior, editableRecordProp } = this.props;
    const enabled =
      editableRecordProp && !record[editableRecordProp] ? false : true;
    if (enabled && recordStartEditingBehavior === "row") {
      return this.showUpdateModal(e, record);
    }
  }

  private buildActionsColumn(
    allowUpdate: boolean,
    allowDelete: boolean,
    columns: any[],
    additionalActions: TGridAction[],
    translate: TTranslate,
    editableRecordProp: string | undefined,
    showUpdateModal: (e: any, rowData: any) => void,
    showDeleteModal: (e: any, rowData: any) => void,
    recordStartEditingBehavior,
    rowClickAction
  ) {
    let _additionalActions = additionalActions.filter(
      (item) => item.id !== rowClickAction
    );
    const hasActions =
      columns.filter((item) => item.action === true).length > 0 ||
      _additionalActions.length > 0;
    const shouldAddActionColumn =
      ((allowUpdate || allowDelete) &&
        recordStartEditingBehavior === "button") ||
      hasActions;
    if (!shouldAddActionColumn) {
      return columns;
    }

    let _actions = [
      ...(allowUpdate
        ? [
            {
              type: "link",
              label: translate("data_grid.update"),
              onClick: (record) => (e) => showUpdateModal(e, record),
              disabled: (record) =>
                editableRecordProp && !record[editableRecordProp] ? false : true
            }
          ]
        : []),
      ...(_additionalActions || []),
      ...(allowDelete
        ? [
            {
              type: "link",
              label: translate("data_grid.remove"),
              onClick: (record) => (e) => showDeleteModal(e, record)
            }
          ]
        : [])
    ];

    columns = [
      ...columns,
      {
        dataIndex: "",
        key: "actions",
        width: this.props.actionColumnWidth || 100,
        fixed: !this.props.expandedRowRender ? "right" : undefined,
        render: (text, record) => {
          return renderGridActionDropdown(_actions as TGridAction[], record);
        }
      }
    ];

    return columns;
  }
}
function renderGridActionDropdown(actions: TGridAction[], record: any) {
  return <GridActionsDropdown actions={actions} record={record} />;
}
